module.exports = __webpack_public_path__ + "static/media/blog.242acbfc.png";